// ─── Units ──────────────────────────────────────────────────────────────────
/**
 * The Settings list (`AppSettingList.listCode`) of what an item line is
 * counted in — each, by the hour, per guest. An item and a catalog item store
 * the value.
 */
export const ITEM_UNIT_LIST_CODE = 'item_units';
/** The units a deploy starts with; the office edits them in Settings. */
export const DEFAULT_ITEM_UNITS = [
    { value: 'each', label: 'Each' },
    { value: 'hour', label: 'Hour' },
    { value: 'day', label: 'Day' },
    { value: 'per_guest', label: 'Per guest' },
    { value: 'set', label: 'Set' },
    { value: 'sq_ft', label: 'Sq ft' },
];
//# sourceMappingURL=planning.js.map